/**
 * action type constants related to fetching the unassigned devices
 */
export const UNASSIGNED_DEVICES_FETCH_REQUEST =
  "UNASSIGNED_DEVICES_FETCH_REQUEST";
export const UNASSIGNED_DEVICES_FETCH_SUCCESS =
  "UNASSIGNED_DEVICES_FETCH_SUCCESS";
export const UNASSIGNED_DEVICES_FETCH_ERROR = "UNASSIGNED_DEVICES_FETCH_ERROR";

export const CHANGE_UNASSIGNED_DEVICES_GRP_MAP =
  "CHANGE_UNASSIGNED_DEVICES_GRP_MAP";

export const SAVE_UNASSIGNED_DEVICES_GRP_MAP_REQUEST =
  "SAVE_UNASSIGNED_DEVICES_GRP_MAP_REQUEST";
export const SAVE_UNASSIGNED_DEVICES_GRP_MAP_SUCCESS =
  "SAVE_UNASSIGNED_DEVICES_GRP_MAP_SUCCESS";
export const SAVE_UNASSIGNED_DEVICES_GRP_MAP_ERROR =
  "SAVE_UNASSIGNED_DEVICES_GRP_MAP_ERROR";

export const CANCEL_UNASSIGNED_DEVICES_GRP_MAP =
  "CANCEL_UNASSIGNED_DEVICES_GRP_MAP";

export const CLOSE_UNASSIGNED_DEVICES_GRP_MSG_POPUP =
  "CLOSE_UNASSIGNED_DEVICES_GRP_MSG_POPUP";

export const RESET_UNASSIGNED__DEVICES_STATE =
  "RESET_UNASSIGNED__DEVICES_STATE";

export const GENERIC_ERROR_MESSAGE =
  "Failed - Due to Technical error, Please try again";
